export const bartStations = [
    {
        station: "Millbrae",
        lat: 37.60024272457756, 
        lng: -122.38679137718664,
        artPresent: true
    },
    {
        station: "San Francisco International Airport",
        lat: 37.61607084768668, 
        lng: -122.39233251833198,
        artPresent: true
    },
    {
        station: "San Bruno",
        lat: 37.62975446778947,
        lng: -122.41135280998543,
        artPresent: true
    },
    {
        station: "South San Francisco",
        lat: 37.66422823561539,
        lng: -122.44404264892236,
        artPresent: true
    },
    {
        station: "Colma",
        lat: 37.68462768678637, 
        lng: -122.46623533035869,
        artPresent: true
    },
    {
        station: "Daly City",
        lat: 37.70625398696978,
        lng: -122.46891916211393,
        artPresent: true
    },
    {
        station: "Balboa Park",
        lat: 37.72176121131468,
        lng: -122.44747769339307,
        artPresent: false
    },
    {
        station: "Glen Park",
        lat: 37.73327488580108,
        lng: -122.4335321604463,
        artPresent: false
    },
    {
        station: "24th St./Mission",
        lat: 37.75227220992046,
        lng: -122.41851844628384,
        artPresent: true
    },
    {
        station: "16th St./Mission",
        lat: 37.76537139357373,
        lng: -122.41961439544926,
        artPresent: true
    },
    {
        station: "Civic Center/UN Plaza",
        lat: 37.77958086998432,
        lng: -122.41371045712741,
        artPresent: false
    },
    {
        station: "Powell",
        lat: 37.78427357243567,
        lng: -122.40782269822968,
        artPresent: true
    },
    {
        station: "Montgomery",
        lat: 37.789412240892915,
        lng: -122.40114468569998,
        artPresent: false
    },
    {
        station: "Embarcadero",
        lat: 37.79287015311189,
        lng: -122.39697900398725,
        artPresent: true
    },
    {
        station: "West Oakland",
        lat: 37.80485865679075,
        lng: -122.29519237040674,
        artPresent: false
    },
    {
        station: "12th St. Oakland",
        lat: 37.80346884095162,
        lng: -122.271651231499,
        artPresent: true
    },
    {
        station: "19th St. Oakland",
        lat: 37.80881586423594,
        lng: -122.26835734051606,
        artPresent: false
    },
    {
        station: "MacArthur",
        lat: 37.82879699553159,
        lng: -122.26715129145953,
        artPresent: true
    },
    {
        station: "Ashby",
        lat: 37.853036190001205,
        lng: -122.26979995911277,
        artPresent: false
    },
    {
        station: "Downtown Berkeley",
        lat: 37.870105535526065,
        lng: -122.26813845490042,
        artPresent: false
    },
    {
        station: "North Berkeley",
        lat: 37.87396528581724,
        lng: -122.28347101004341,
        artPresent: false
    },
    {
        station: "El Cerrito Plaza",
        lat: 37.90261795422141,
        lng: -122.29895374345318,
        artPresent: true
    },
    {
        station: "El Cerrito del Norte",
        lat: 37.92516462484263,
        lng: -122.31692763825261,
        artPresent: true
    },
    {
        station: "Richmond",
        lat: 37.93674683701101,
        lng: -122.35304897225313,
        artPresent: true
    },
    {
        station: "Rockridge",
        lat: 37.844773161947735,
        lng: -122.2512268152199,
        artPresent: true
    },
    {
        station: "Orinda",
        lat: 37.87846846199484,
        lng: -122.18373660128545,
        artPresent: true
    },
    {
        station: "Lafayette",
        lat: 37.89320557298469,
        lng: -122.12468906601272,
        artPresent: true
    },
    {
        station: "Walnut Creek",
        lat: 37.905831677519785,
        lng: -122.067326619442,
        artPresent: false
    },
    {
        station: "Pleasant Hill",
        lat: 37.928439410524554,
        lng: -122.05604849215639,
        artPresent: false
    },
    {
        station: "Concord",
        lat: 37.973714683858354,
        lng: -122.02911725291993,
        artPresent: false
    },
    {
        station: "North Concord/Martinez",
        lat: 38.00335089099974,
        lng: -122.024578605989,
        artPresent: false
    },
    {
        station: "Pittsburg/Bay Point",
        lat: 38.01891436754169,
        lng: -121.9451547886641,
        artPresent: false
    },
    {
        station: "Pittsburg Center",
        lat: 38.01686112241146,
        lng: -121.88912669584558,
        artPresent: false
    },
    {
        station: "Antioch",
        lat: 37.9954399473275, 
        lng: -121.78049121286341,
        artPresent: false
    },
    {
        station: "Lake Merritt",
        lat: 37.79708384135932,
        lng: -122.265269214711,
        artPresent: true
    },
    {
        station: "Fruitvale",
        lat: 37.774777647559645,
        lng: -122.22409945571924,
        artPresent: true
    },
    {
        station: "Coliseum",
        lat: 37.75364647645824,
        lng: -122.19684549185124,
        artPresent: false
    },
    {
        station: "Oakland Airport Connector - Coliseum Station",
        lat: 37.752311841936454,
        lng: -122.1961891712258,
        artPresent: true
    },
    {
        station: "Oakland Airport Connector - Airport",
        lat: 37.713254072951976,
        lng: -122.21225707220404,
        artPresent: true
    },
    {
        station: "San Leandro",
        lat: 37.72179347101787,
        lng: -122.16077992942458,
        artPresent: false
    },
    {
        station: "Bay Fair",
        lat: 37.696949776873225,
        lng: -122.1264655206889,
        artPresent: false
    },
    {
        station: "Castro Valley",
        lat: 37.69077598611542,
        lng: -122.07561692377772,
        artPresent: false
    },
    {
        station: "West Dublin/Pleasanton",
        lat: 37.699702415955954,
        lng: -121.92833534236414,
        artPresent: false
    },
    {
        station: "Dublin/Pleasanton",
        lat: 37.701587854251414,
        lng: -121.89926838524453,
        artPresent: false
    },
    {
        station: "Hayward",
        lat: 37.669734102716035,
        lng: -122.08696658317209,
        artPresent: false
    },
    {
        station: "South Hayward",
        lat: 37.63437542482882,
        lng: -122.05721388295525,
        artPresent: false
    },
    {
        station: "Union City",
        lat: 37.590636474035456,
        lng: -122.01731727399913,
        artPresent: true
    },
    {
        station: "Fremont",
        lat: 37.557443481138,
        lng: -121.97665042653831,
        artPresent: true
    },
    {
        station: "Warm Springs",
        lat: 37.50216092394219,
        lng: -121.93930777264185,
        artPresent: true
    },
    {
        station: "Milpitas",
        lat: 37.410250081847394,
        lng: -121.89106841353144,
        artPresent: false
    },
    {
        station: "Berryesa/North San Jose",
        lat: 37.368464582049484,
        lng: -121.87471010936808,
        artPresent: false
    },
];